import ServiceRequest from './ServiceRequest';

// /book-consultation — the consultation flavour of the shared request form.
// Kept as its own route because it's the link already in use across the site
// and in sent emails.
export default function BookConsultation() {
  return <ServiceRequest kind="consultation" />;
}
